
import Button from "@/components/base/Button"
import PreviewCard from "@/components/job/editor/JobPagePreviewCard"
import Swiper, { EffectCoverflow, Navigation } from "swiper"
import "swiper/swiper.scss"

import { getJobBySlug } from "@/services/v2/job.service"
import { Search } from "@/models/search"
import { routeToJob } from "@/helpers/routing"
import { mdiChevronRight, mdiChevronLeft } from "@mdi/js"

export default {
    name: "JobCarousel",
    components: { PreviewCard, Button },
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
    icons: {
        mdiChevronRight,
        mdiChevronLeft,
    },
    async fetch() {
        if (this.blok.items) {
            await this.fetchItems()
        } else if (this.blok.channel) {
            await this.fetchChannel()
        }
        if (process.client) {
            this.initSwiper()
        }
    },
    data: () => ({
        items: [],
        isSwiperInit: false,
    }),
    async mounted() {
        if (this.blok.items) {
            await this.fetchItems()
        } else if (this.blok.channel) {
            await this.fetchChannel()
        }
        if (this.items.length) {
            this.initSwiper()
        }
    },
    methods: {
        routeToJob(job) {
            return routeToJob(job)
        },
        async fetchItems() {
            const items = this.blok.items.split(",").map((item) => item.trim())
            const promises = items.map(async (item) => {
                return this.$api.run(getJobBySlug, item).request
            })
            const resolved = await Promise.allSettled(promises)
            this.items = resolved
                .filter((item) => item.value)
                .map((item) => item.value)
        },
        async fetchChannel() {
            const search = new Search({
                type: "apprenticeship",
                channel: this.blok.channel,
                perPage: 15,
            })
            await search.execute()
            this.items = search.data
        },
        initSwiper() {
            if (this.isSwiperInit) return
            this.isSwiperInit = true
            this.swiper = new Swiper(this.$refs.swiper, {
                effect: "coverflow",
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "auto",
                initialSlide: this.items.length / 2,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: false,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                modules: [EffectCoverflow, Navigation],
            })
        },
    },
}
